import { useFeatureFlags } from "@packsize/feature-flags";

import { MissingFeatureFlag } from "../../missing-feature-flag";

interface FeatureFlaggedRouteProps {
	readonly children: React.ReactNode;
	readonly featureFlag: string;
}

export const FeatureFlaggedRoute: React.FC<FeatureFlaggedRouteProps> = ({ children, featureFlag }) => {
	const { isFeatureFlagEnabled } = useFeatureFlags();

	if (isFeatureFlagEnabled(featureFlag) !== true) {
		return <MissingFeatureFlag />;
	}

	return children;
};
